
export const chatHost = 'chat-staging.noody.net';
export const httpURL = `https://${chatHost}`;
export const wsURL = `wss://${chatHost}/messages`;
